// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"index-module--cardsContainer--1gg4c","sidebarContainer":"index-module--sidebarContainer--2z3G_","clear":"index-module--clear--1Qt8E"};